
// import Landing from '@/components/Home/Landing'
// import Pricing from '@/components/Home/Pricing'
// import signup from '@/components/Home/signup'
const Landing = () => import('@/components/Home/Landing')
const Pricing = () => import('@/components/Home/Pricing')
const Signup = () => import('@/components/Home/Signup')
const routes = [
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing,
  },
  {
    path: '/',
    name: 'main-home',
    component: Landing,
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: Signup,
  },

  
]

export default routes